// extracted by mini-css-extract-plugin
export var bodySections = "_9t-8";
export var gray = "_9t-7";
export var green = "_9t-4";
export var iconContainer = "_9t-9";
export var iconWidgetContainer = "_9t-1";
export var phoneIcon = "_9t-2";
export var red = "_9t-5";
export var statusDot = "_9t-3";
export var widgetContainer = "_9t-0";
export var yellow = "_9t-6";